module.exports = __webpack_public_path__ + "static/media/experience.f710a8fc.svg";